import { RootReducerType } from "../CombineReducer";

export const useGetProfileData = (state: RootReducerType) => state.profileInfo.profileInfo;
export const useGetProfileImage = (state: RootReducerType) => state.profileInfo.profileInfo?.imageUrl;